var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.42774 9.61157C2.32206 9.71725 2.2627 9.86057 2.2627 10.01C2.2627 10.1595 2.32206 10.3028 2.42774 10.4084C2.53341 10.5141 2.67673 10.5735 2.82617 10.5735C2.97562 10.5735 3.11894 10.5141 3.22461 10.4084L6.2007 7.43142L9.17774 10.4075C9.28341 10.5132 9.42673 10.5725 9.57617 10.5725C9.72562 10.5725 9.86894 10.5132 9.97461 10.4075C10.0803 10.3018 10.1396 10.1585 10.1396 10.0091C10.1396 9.85963 10.0803 9.71631 9.97461 9.61064L6.99758 6.63454L9.97367 3.65751C10.0793 3.55184 10.1387 3.40852 10.1387 3.25907C10.1387 3.10963 10.0793 2.96631 9.97367 2.86064C9.868 2.75496 9.72468 2.6956 9.57524 2.6956C9.42579 2.6956 9.28247 2.75496 9.1768 2.86064L6.2007 5.83767L3.22367 2.86017C3.118 2.7545 2.97468 2.69513 2.82524 2.69513C2.67579 2.69513 2.53247 2.7545 2.4268 2.86017C2.32113 2.96584 2.26176 3.10916 2.26176 3.25861C2.26176 3.40805 2.32113 3.55137 2.4268 3.65704L5.40383 6.63454L2.42774 9.61157Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/xIcon.461c3505.svg";
export { ForwardRef as ReactComponent };